module.exports = __webpack_public_path__ + "img/发展历史.860ac7b7.png";